var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"inputmode":_vm.isNumericMask ? 'numeric' : 'text',"maxLength":_vm.maxLength,"rules":_vm.applyRules},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }